/* eslint-disable */
import session from './session'
import apiurl from './baseurl'
import axios from 'axios'
//import store from '../store/store'

export default {
  login(username, password) {
    return session.post(apiurl.proxy + apiurl.api3 + 'user/login', {
      username,
      password
    })
  },
  createAccount0(
    user_role,
    mail,
    pass,
    terms,
    doctor_professional_number,
    user_name,
    user_surname,
    user_surname2,
    doctor_jobcenter,
    doctor_jobcenter_other,
    administrative_area,
    country,
    doctor_specialty_main,
    doctor_title,
    doctor_resident,
    doctor_resident_year,
    doctor_professional_doc,
    doctor_professional_doc_base64
  ) {
    let config = {
      mail: mail,
      pass: pass,
      terms: terms
    }

    if (user_role !== '') {
      config = Object.assign({ user_role: user_role }, config)
    }

    if (user_name !== '') {
      config = Object.assign({ user_name: user_name }, config)
    }

    if (user_surname !== '') {
      config = Object.assign({ user_surname: user_surname }, config)
    }

    if (user_surname2 !== '') {
      config = Object.assign({ user_surname2: user_surname2 }, config)
    }

    if (administrative_area !== '') {
      config = Object.assign(
        { administrative_area: administrative_area },
        config
      )
    }

    if (country !== '') {
      config = Object.assign({ country: country }, config)
    }

    if (doctor_jobcenter == '') {
      config = Object.assign(
        { doctor_jobcenter_other: doctor_jobcenter_other }, config)
    } else {
      config = Object.assign({ doctor_jobcenter: doctor_jobcenter }, config)
    }

    if (doctor_professional_doc_base64 !== null) {
      config = Object.assign({ doctor_professional_doc: doctor_professional_doc }, config);
    }

    // Si es doctor añadimos los campos que faltan
    if (user_role === 'doctor') {
      config = Object.assign(
        {
          doctor_resident: doctor_resident,
          // doctor_professional_number: doctor_professional_number,
          // doctor_specialty_main: doctor_specialty_main,
          doctor_title: doctor_title
        },
        config
      )
      if (doctor_resident_year != 0) {
        config = Object.assign(
          { doctor_resident_year: doctor_resident_year },
          config
        )
      }
    }

    if (doctor_professional_number !== '') {
      config = Object.assign({ doctor_professional_number: doctor_professional_number }, config)
    }

    if (doctor_specialty_main !== '') {
      config = Object.assign({ doctor_specialty_main: doctor_specialty_main }, config)
    }

    let post = session.post(apiurl.navandume + 'api/user/register', config)
    return post
  },
  logout() {
    return session.get(apiurl.proxy + 'user/logout/all', {})
  },
  resetPassword(email) {
    console.log('Destination: ' + apiurl.proxy)
    return axios.post(
      apiurl.navandume + 'api/user/request_new_password_destination',
      {
        name: email,
        destination: apiurl.proxy
      }
    )
  },
  /*getProfile(mail, pass, terms) {
    return session.get(apiurl.navandume+'api/profile/current')
  }, */
  getUserPhoto() {
    return session.get(apiurl.proxy + 'api/v1.0/userphoto')
  },
  setUserPhoto(photo) {
    return session.post(apiurl.proxy + 'api/v1.0/userphoto', photo )
  },
  deleteUserPhoto() {
    return session.delete(apiurl.proxy + 'api/v1.0/userphoto')
  },
  getUserProfile(mail, pass, terms) {
    return session.get(apiurl.proxy + 'api/v4.0/user')
  },
  updateProfile(
    doctor_professional_number,
    user_name,
    user_surname,
    user_surname2,
    doctor_jobcenter,
    doctor_jobcenter_other,
    administrative_area,
    country,
    doctor_specialty_main,
    doctor_title,
    doctor_resident,
    doctor_resident_year
  ) {
    let obj = {
      user_name,
      user_surname,
      user_surname2
    }
    if (doctor_professional_number !== undefined) {
      obj = Object.assign(
        { doctor_professional_number: doctor_professional_number },
        obj
      )
    }
    if (doctor_jobcenter !== undefined) {
      obj = Object.assign({ doctor_jobcenter: doctor_jobcenter }, obj)
    }
    if (doctor_jobcenter_other !== undefined) {
      obj = Object.assign(
        { doctor_jobcenter_other: doctor_jobcenter_other },
        obj
      )
    }
    if (administrative_area !== undefined) {
      obj = Object.assign({ administrative_area: administrative_area }, obj)
    }
    if (country !== undefined) {
      obj = Object.assign({ country: country }, obj)
    }
    if (doctor_specialty_main !== undefined) {
      obj = Object.assign({ doctor_specialty_main: doctor_specialty_main }, obj)
    }
    if (doctor_title !== undefined) {
      obj = Object.assign({ doctor_title: doctor_title }, obj)
    }
    if (doctor_resident !== undefined) {
      obj = Object.assign({ doctor_resident: doctor_resident }, obj)
    }
    if (doctor_resident_year !== undefined) {
      obj = Object.assign({ doctor_resident_year: doctor_resident_year }, obj)
    }
    console.log('api/updateProfile --> JSONOBJ')
    console.log(obj)

    return session.patch(apiurl.proxy + 'api/v4.0/user', obj)
  }
  //TBD
  /*  changeAccountPassword(password1, password2) {
    return session.post(apiurl.base+apiurl.api1+'rest-auth/password/change/', { password1, password2 })
  },
  sendAccountPasswordResetEmail(email) {
    return session.post(apiurl.base+apiurl.api1+'rest-auth/password/reset/', { email })
  },
  resetAccountPassword(uid, token, new_password1, new_password2) { // eslint-disable-line camelcase
    return session.post(apiurl.base+apiurl.api1+'rest-auth/password/reset/confirm/', { uid, token, new_password1, new_password2 })
  },
  getAccountDetails() {
    return session.get(apiurl.base+apiurl.api1+'rest-auth/user/')
  },
  updateAccountDetails(data) {
    return session.patch(apiurl.base+apiurl.api1+'rest-auth/user/', data)
  },
  verifyAccountEmail(key) {
    return session.post(apiurl.base+apiurl.api1+'/registration/verify-email/', { key })
  } */
}
